export default {
  searchText(state) {
    return state.searchText;
  },
  stringFilter(state) {
    let filter = '(situacao not in ("RASCUNHO")';
    if (state.searchText) {
      filter += ` and nome like '%${state.searchText.toLowerCase()}%'`;
    }
    filter += ')';
    return filter;
  },
};
